<template>
    <div class="hot-article-container">
        <div class="title-box">
            <span class="title">热门文章</span>
        </div>
        <div class="list-box">
            <ul>
                <li v-for="(item, i) in hotArticleList" :key="i">
                    <div class="img-box">
                        <img :src="item.article&&item.article.cover?item.article.cover:''" alt="">
                    </div>
                    <div class="info-box">
                        <div class="title" @click="toArticleDetail(item.article.id)">{{item.article && item.article.title}}</div>
                        <div class="time">{{item.article && item.article.created_at}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HotArticle',
    data() {
        return {}
    },
    computed: {
        // 当前所在栏目
        columnId() {
            return this.$store.state.pc.nowColumnParams.columnId;
        },
        // 栏目名称
        columnName() {
            return this.$store.state.pc.nowColumnParams.columnName;
        },
        hotArticleList() {
            return this.$store.state.articleModules.hotList;
        }
    },
    created() {
    },
    methods: {
        /**
         * @function toArticleDetail 去文章详情
         */
        toArticleDetail(id) {
            // let path = this.columnId == 1 ? '/' : '/columnContentListP';
            // let breadcrumbList = [
            //     { name: this.columnName, path: path, column_id: this.columnId }
            // ];
            // this.$store.commit('setBreadcrumbList', breadcrumbList);
            this.$router.push({ 
                path: '/articleDetailP', 
                query: { 
                    article_id: id,
                    article_key: '',
                    from_user_id: '',
                    top_user_id: 0,
                    parent_article_key: ''
                } 
            });
            let nowPath = this.$route.path;
            if(nowPath == '/articleDetailP') {
                this.Bus.$emit('dataChange', true);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import './HotArticle.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/hot-article/HotArticle.vue